<template>
  <div class="socialsentenze">
    <h3>Commenti</h3>
    <BootstrapTable
      :columns="columns"
      :data="commenti"
      :options="options"
    />

    <b-modal ref="edit-modal" hide-footer title="Modifica commento">
      <div class="d-block text-center">
        <vue-editor v-model="commentoInput" :editor-toolbar="customToolbar" ref="editor" placeholder="Scrivi la massima o il commento di questa sentenza..." />
      </div>
      <b-button class="btn-success" @click="salvaCommento">Salva</b-button>
      <b-button @click="chiudModal">Chiudi</b-button>
    </b-modal>

    <b-modal ref="premassima-modal" hide-footer title="Inserisci la premassima">
      <div class="d-block text-center">
        <vue-editor v-model="commentoInput" :editor-toolbar="customToolbar" ref="editor" placeholder="Scrivi la premassima..." />
      </div>
      <b-button class="btn-success" @click="approva">Approva aggiungendo la premassima</b-button>
      <b-button @click="chiudModalPremassima">Chiudi</b-button>
    </b-modal>
  </div>
</template>

<script>
import services from '../../services/service.js'

import { VueEditor } from "vue2-editor";

export default {
  name: 'socialsentenze',
  components: {
    VueEditor
  },
  data () {
    return {
      commentoInput: '',
      commentoId : null,
      premassimaEdit: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]
      ],
      columns: [
        {
          title: 'Id',
          field: 'id',
          visible: false
        },
        {
          title: 'Sentenza Id',
          field: 'sentenzaId',
          visible: false
        },
        {
          title: 'Avvocato',
          field: 'avvocato',
          sortable: true
        },
        {
          title: 'Testo',
          formatter: function(value, row, index, field) {
            return '<b>' + row.premassima + '</b><hr/>' + row.testo;
          },
          sortable: true,
          class: 'text-justify'
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            return '<button type="button" class="btn btn-info">Modifica</button>';
          },
          events: {
            'click .btn': this.modifica
          }
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            return '<button type="button" class="btn btn-danger">Elimina</button>';
          },
          events: {
            'click .btn': this.eliminaCommento
          }
        },
        {
          title: 'Data inserimento',
          field: 'dataInserimento',
          sortable: true
        },
        {
          title: 'Materia',
          field: 'sentenzaMateria',
          sortable: true
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            let href = '/sentenza/' + row.sentenzaId;
            return `<a type="button" class="btn btn-primary" target="_blank_" href="${href}">Apri sentenza</a>`;
          }
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            if(row.approvata)
              return '<button type="button" class="btn btn-info">Modifica premassima</button>';
            return '<button type="button" class="btn btn-success">Approva</button>';
          },
          events: {
            'click .btn-success': this.modalApprova,
            'click .btn-info': this.modalModificaPremassima
          }
        }
      ],
      commenti: [],
      options: {
        search: true
      }
    }
  },
  methods: {
    async getData() {
      this.commenti = await services.execute('get', 'commento/admin');
    },
    modalModificaPremassima(event, value, row, index){
      this.premassimaEdit = true;
      this.modalApprova(event, value, row, index);
    },
    modalApprova(event, value, row, index){
      this.commentoInput = row.premassima;

      this.commentoId = row.id;
      this.$refs['premassima-modal'].show();
    },
    approva() {
      let url = 'commento/' + this.commentoId;

      let data = {
        premassima: this.commentoInput
      };

      let that = this;
      services.execute('put', url, data).then(async (data) => {
        if(!that.premassimaEdit){
          await services.execute('post', url);
        }

        that.getData();
        that.chiudModalPremassima();
      });
    },
    modifica(event, value, row, index){
      this.commentoInput = row.testo;
      this.commentoId = row.id;
      this.$refs['edit-modal'].show()
    },
    eliminaCommento(event, value, row, index){
      if(confirm("Eliminare il commento?")){
        let url = 'commento/' + row.id;

        let that = this;
        services.execute('delete', url).then((data) => {
          that.getData();
        });
      }
    },
    salvaCommento(){
      let url = 'commento/' + this.commentoId;

      let data = {
        testo: this.commentoInput
      };

      let that = this;
      services.execute('put', url, data).then((data) => {
        that.getData();
        that.chiudModal();
      });
    },
    chiudModal(){
      this.$refs['edit-modal'].hide()
    },
    chiudModalPremassima(){
      this.premassimaEdit = false;  
      this.$refs['premassima-modal'].hide();
    }
  },
  async created() {
    await this.getData();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
.modal-header{
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SocialSentenze.vue